import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../services/auth.service";
import {ReplaySubject} from "rxjs";

export interface LoginLockDialogData {
  startAt: string;
  endAt: string;
}

@Component({
  selector: 'app-login-lock-dialog',
  templateUrl: './login-lock-dialog.component.html',
  styleUrls: ['./login-lock-dialog.component.scss']
})
export class LoginLockDialogComponent implements OnDestroy, OnInit {
  startAt = '';
  endAt = '';

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<LoginLockDialogComponent>,
    private authService: AuthService,
  @Inject(MAT_DIALOG_DATA) public data: LoginLockDialogData
  ) {
    this.startAt = data.startAt;
    this.endAt = data.endAt;
    this.authService.loadProfile();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  decline(): void {
    this.dialogRef.close(false);
  }
}
